import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import IdleVue from 'idle-vue';
import VuePluralize from 'vue-pluralize';
import { IDLE_TIME } from "../common/consts";
// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/cli-documentation/boot-files#Anatomy-of-a-boot-file
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, store;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          Vue = _ref.Vue, store = _ref.store;
          // IdleVue
          Vue.use(IdleVue, {
            store: store,
            startAtIdle: false,
            events: ['keydown', 'mousemove', 'touchstart'],
            idleTime: 1000 * IDLE_TIME
          });

          // VuePluralize
          Vue.use(VuePluralize);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();